declare global {
  interface Window {
    ReactNativeWebView?: { postMessage: (message: string) => void };
  }
}

const postWebViewMessage = (type: string, data: Record<string, unknown> = {}): void => {
  window.ReactNativeWebView?.postMessage(JSON.stringify({
    type,
    ...data,
  }));
};

const appNavigate = (tab: string, params: Record<string, unknown> = {}): void => {
  postWebViewMessage('navigate', { tab, params });
};

interface LoginStatus {
  isLoggedIn: boolean;
  username?: string;
  logo?: string;
  hasInterventionPointTab?: boolean;
  email?: string;
  role?: string;
  canCreateRequests?: boolean;
  /**
   * Which screens the native shell may render itself, served by `/api/me` from `NATIVE_SCREENS`.
   * Absent means OFF everywhere — an unset variable, an older server, no network — and OFF is the
   * mode that always works, because the web page is right there (D12).
   */
  nativeScreens?: Record<string, boolean>;
}

const postLoginStatus = ({ isLoggedIn, username, logo, hasInterventionPointTab, email, role, canCreateRequests, nativeScreens }: LoginStatus): void => {
  postWebViewMessage('loggedIn', { isLoggedIn, username, logo, hasInterventionPointTab, email, role, canCreateRequests, nativeScreens });
};

export { appNavigate, postWebViewMessage, postLoginStatus };
